import { CommunityDetailsSection, LabelsSection } from '@communities/content-management/components';
import { PromptsSection } from '@communities/prompt-management/components';
import { FEATURE_FLAGS } from '@core/domain';
import { useIsFeatureEnabled } from '@core/hooks';
import { withAppInsightsTracking } from '@core/logging/withAppInsightsTracking';
import { Section } from '@soteria/design-system-ve';

interface CommunityContextTabProps {
  entityId: string;
  isEntityAdmin: boolean;
  onEditCommunity?: () => void;
}

function CommunityContextTabComponent({ entityId, isEntityAdmin, onEditCommunity }: CommunityContextTabProps) {
  const isStandardLabelsEnabled = useIsFeatureEnabled(FEATURE_FLAGS.STANDARD_LABELS);

  return (
    <>
      {/* Community Details Section */}
      <Section spacing="medium">
        <CommunityDetailsSection onEditCommunity={isEntityAdmin ? onEditCommunity : undefined} />
      </Section>

      {/* Labels Section */}
      {isStandardLabelsEnabled && (
        <Section spacing="medium">
          <LabelsSection />
        </Section>
      )}

      {/* Prompts Section - Only for Communities and Admins */}
      {isEntityAdmin && (
        <Section spacing="medium">
          <PromptsSection communityId={entityId} isCommunityAdmin={isEntityAdmin} />
        </Section>
      )}
    </>
  );
}

export const CommunityContextTab = withAppInsightsTracking(CommunityContextTabComponent, 'CommunityContextTab');
